<template>
    <div>
        <b-form-group ref="form-group">
            <template slot="label">
                <b-form-checkbox
                    ref="parent-checkbox"
                    v-model="allSelected"
                    :indeterminate="indeterminate"
                    aria-describedby="permission"
                    aria-controls="permission"
                    @change="toggleAll"
                >
                    <span>{{ parentName }}</span>
                </b-form-checkbox>
            </template>
            <b-form-checkbox-group
                :id="checkboxName"
                ref="child-checkbox"
                v-model="selected"
                v-bind="$attrs"
                :options="checkBoxListing"
                :name="checkboxName"
                class="ml-4"
                stacked
            ></b-form-checkbox-group>
        </b-form-group>
    </div>
</template>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'
export default {
    props: {
        checkBoxListing: {
            type: Array,
            default: null,
        },
        checkboxName: {
            type: String,
            default: 'checkboxes',
        },
        parentName: {
            type: String,
            default: null,
        },
        // selectedValues: {
        //     type: Array,
        //     default: null,
        // },
    }, // End of Component > props

    data() {
        return {
            selected: [],
            allSelected: this.checker(),
            indeterminate: this.checkIndeterminate(),
        }
    },
    computed: {
        ...mapGetters(['selectedItem']),
        selectedValues() {
            return this.selectedItem && this.selectedItem.permissions
                ? this.selectedItem.permissions
                : []
        },
    }, // End of Component > computed
    watch: {
        selected(newVal) {
            if (newVal.length === 0) {
                this.indeterminate = false
                this.allSelected = false
            } else if (this.containsAll(this.checkBoxListing, newVal)) {
                this.indeterminate = false
                this.allSelected = true
            } else {
                this.indeterminate = true
                this.allSelected = false
            }
            this.$emit(
                'get-selected',
                newVal,
                this.parentName,
                this.allSelected,
                'checkbox'
            )
        },
    }, // End of Component > watch
    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {
        this.setValues()
    },
    methods: {
        toggleAll(checked) {
            this.selected = checked ? _.map(this.checkBoxListing, 'value') : []
        },
        checker() {
            let list = _.map(this.checkBoxListing, 'value')
            if (this.selectedValues) {
                return list.every((v) => this.selectedValues.includes(v))
            }
        },
        checkIndeterminate() {
            let commonValues = _.intersection(
                this.selectedValues,
                _.map(this.checkBoxListing, 'value')
            )

            if (this.selectedValues && this.selectedValues.length === 0) {
                return false
            }
            if (commonValues.length === this.checkBoxListing.length) {
                return false
            }
            if (
                commonValues.length < this.checkBoxListing.length &&
                commonValues.length !== 0
            ) {
                return true
            }
            return false
        },
        async setValues() {
            this.selected = await _.intersection(
                this.selectedValues,
                _.map(this.checkBoxListing, 'value')
            )
        },
        containsAll(needles, haystack) {
            if (haystack) {
                for (var i = 0; i < needles.length; i++) {
                    if (!haystack.includes(needles[i].value)) return false
                }
            }
            return true
        },
    },
}
</script>
